/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Hash { 
    value: string;
    algorithm: Hash.AlgorithmEnum;
}
export namespace Hash {
    export const AlgorithmEnum = {
        Sha256: 'SHA-256',
        Sha384: 'SHA-384',
        Sha512: 'SHA-512',
        Sha3256: 'SHA3-256',
        Sha3384: 'SHA3-384',
        Sha3512: 'SHA3-512'
    } as const;
    export type AlgorithmEnum = typeof AlgorithmEnum[keyof typeof AlgorithmEnum];
}


